import helperFunctions from "@/components/RenderedDie/shaders/helperFunctions.frag";
import { shaderMaterial } from "@react-three/drei";
import { extend } from "@react-three/fiber";

export const SanguineCoreLightMaterial = shaderMaterial(
  {
    iGlobalTime: 0.0,
    u_PumpRate: 1.75,
    u_float: 0.5,
    u_float1: 0.7,
    u_Vector: [0.5, 0.5, 0.5],
    textureInfoName: 1.0,
    textureInfoName1: 1.0,
    TextureTexture: null,
    Texture1Texture: null,
  },
  `
  // Vertex shader
  #if defined(WEBGL2) || defined(WEBGPU)
  precision highp sampler2DArray;
  #endif
  precision highp float;
  // Force Babylon-style conditional branch usage for UV
  #define VMAINUV

  //Attributes
  // attribute vec3 position;
  // #ifdef UV1
  // attribute vec2 uv;
  // #else
  // vec2 uv = vec2(0.);
  // #endif


  //Uniforms
  uniform float iGlobalTime;
  uniform float u_PumpRate;
  uniform float u_float;
  uniform float u_float1;
  // Three.js injects modelMatrix, viewMatrix, projectionMatrix, modelViewMatrix automatically
  #ifdef UVTRANSFORM0
  uniform mat4 textureTransform;
  #endif
  uniform vec3 u_Vector;
  #ifdef UVTRANSFORM1
  uniform mat4 textureTransform1;
  #endif


  //Samplers
  uniform  sampler2D TextureTexture; 
  uniform  sampler2D Texture1Texture; 


  //Varyings
  #ifdef UVTRANSFORM0
  varying vec2 transformedUV;
  #endif
  #ifdef VMAINUV
  varying vec2 vMainuv;
  #endif
  #ifdef UVTRANSFORM1
  varying vec2 transformedUV1;
  #endif
  varying float v_output4;




  //Entry point
  void main(void) {

  //Normalize
  vec3 output3 = normalize(position);

  //Multiply
  float output10 = iGlobalTime * u_PumpRate;

  //Sin
  float output9 = sin(output10);

  //Abs
  float output8 = abs(output9);

  //Negate
  float output7 = -1.0 * output8;

  //Add
  float output6 = output7 + u_float;

  //Abs
  float output5 = abs(output6);

  //Add
  float output4 = output5 + u_float1;

  //Lerp
  vec3 output2 = mix(output3 , position, output4);

  // world -> view -> clip using built-in matrices
  vec4 mvPosition = modelViewMatrix * vec4(output2, 1.0);
  gl_Position = projectionMatrix * mvPosition;

  //Texture
  #ifdef UVTRANSFORM0
  transformedUV = vec2(textureTransform * vec4(uv.xy, 1.0, 0.0));
  #elif defined(VMAINUV)
  vMainuv = uv.xy;
  #endif

  //Texture
  #ifdef UVTRANSFORM1
  transformedUV1 = vec2(textureTransform1 * vec4(uv.xy, 1.0, 0.0));
  #elif defined(VMAINUV)
  vMainuv = uv.xy;
  #endif
  v_output4 = output4;

  }
`,
  `
  // Fragment shader
  #if defined(PREPASS)
  #extension GL_EXT_draw_buffers : require
  layout(location = 0) out highp vec4 glFragData[SCENE_MRT_COUNT];
  highp vec4 gl_FragColor;
  #endif
  #if defined(WEBGL2) || defined(WEBGPU)
  precision highp sampler2DArray;
  #endif
  precision highp float;
  // Force Babylon-style conditional branch usage for UV
  #define VMAINUV

  //Uniforms
  uniform float iGlobalTime;
  uniform float u_PumpRate;
  uniform float u_float;
  uniform float u_float1;
  // Built-in matrices used: modelMatrix, viewMatrix, projectionMatrix, modelViewMatrix (auto-provided)
  #ifdef UVTRANSFORM0
  uniform mat4 textureTransform;
  #endif
  uniform vec3 u_Vector;
  #ifdef UVTRANSFORM1
  uniform mat4 textureTransform1;
  #endif
  uniform float textureInfoName;
  uniform float textureInfoName1;


  //Samplers
  uniform  sampler2D TextureTexture; 
  uniform  sampler2D Texture1Texture; 


  //Varyings
  #ifdef UVTRANSFORM0
  varying vec2 transformedUV;
  #endif
  #ifdef VMAINUV
  varying vec2 vMainuv;
  #endif
  #ifdef UVTRANSFORM1
  varying vec2 transformedUV1;
  #endif
  varying float v_output4;


  //Texture
  ${helperFunctions}

  //Entry point
  void main(void) {

  //Texture (ensure tempTextureRead2 always declared)
  vec4 tempTextureRead2;
  #ifdef UVTRANSFORM0
    tempTextureRead2 = texture2D(TextureTexture, transformedUV);
  #elif defined(VMAINUV)
    tempTextureRead2 = texture2D(TextureTexture, vMainuv);
  #else
    // Fallback: attempt to use vMainuv even if define missing
    tempTextureRead2 = texture2D(TextureTexture, vMainuv);
  #endif
  vec3 rgb = tempTextureRead2.rgb * textureInfoName;
  #ifdef ISGAMMA2
                  rgb = toLinearSpace(rgb);
                  #endif
              
  //VectorMerger
  vec3 xyz2 = vec3(v_output4, v_output4, v_output4).xyz;

  //One minus
  vec3 output14 = 1. - xyz2;

  //Add
  vec3 output13 = output14 + u_Vector;

  //Texture (ensure tempTextureRead3 always declared)
  vec4 tempTextureRead3;
  #ifdef UVTRANSFORM1
    tempTextureRead3 = texture2D(Texture1Texture, transformedUV1);
  #elif defined(VMAINUV)
    tempTextureRead3 = texture2D(Texture1Texture, vMainuv);
  #else
    tempTextureRead3 = texture2D(Texture1Texture, vMainuv);
  #endif
  vec3 rgb1 = tempTextureRead3.rgb * textureInfoName1;
  #ifdef ISGAMMA3
                  rgb1 = toLinearSpace(rgb1);
                  #endif
              
  //Multiply
  vec3 output12 = output13 * rgb1;

  //Add
  vec3 output11 = rgb + output12;

  //fragmentOutput
  gl_FragColor  = vec4(output11, 1.0);
  #ifdef CONVERTTOLINEAR0
  gl_FragColor  = toLinearSpace(gl_FragColor);
  #endif
  #ifdef CONVERTTOGAMMA0
  gl_FragColor  = toGammaSpace(gl_FragColor);
  #endif
  #if defined(PREPASS)
  gl_FragData[0] = gl_FragColor;
  #endif

  }
`,
);

extend({ SanguineCoreLightMaterial });
